import { createFileRoute, Link, Outlet } from '@tanstack/react-router';
import { ScrollArea } from '~/primitives/scroll-area';
import { ListTabSwitch } from '~/partials/TabSwitch';

export const Route = createFileRoute('/_authenticated/staff/_recordsLayout')({
    loaderDeps: ({ search: { list } }) => ({ list }),
    component: Records,
});

function Records() {
    return (
        <main className="h-full flex justify-center">
            <div className="flex flex-col items-center gap-4 w-full h-full bg-background-dark rounded-2xl py-4">
                <ScrollArea className="w-full p-4 lg:h-[calc(100vh-150px)]">
                    <div className="flex flex-col xl:flex-row xl:justify-between items-center my-2 gap-2">
                        <div className="flex flex-col xl:flex-row items-center gap-2">
                            <div className="flex items-center gap-2">
                                <Link to="/staff/records">
                                    <h1 className="text-secondary-foreground hover:text-secondary-light transition-colors">
                                        Records
                                    </h1>
                                </Link>
                            </div>
                            <ListTabSwitch resetSearch from="/staff/records/" />
                        </div>
                    </div>
                    <Outlet />
                </ScrollArea>
            </div>
        </main>
    );
}
